import { animated } from "react-spring"

interface LogoHorizontalProps {
  className?: string
  onyxSpringStyle?: any
  plusSpringStyle?: any
  roseSpringStyle?: any
  underlineSpringStyle?: any
}
export default function LogoHorizontal({
  className = "fill-black",
  onyxSpringStyle,
  plusSpringStyle,
  roseSpringStyle,
  underlineSpringStyle,
}: LogoHorizontalProps) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 582 80"
    >
      <animated.g id="onyx" style={onyxSpringStyle}>
        <path
          className={className}
          d="M25.27 51.98C11.57 51.98 0 40.08 0 25.99 0 11.9 11.57 0 25.27 0 39.2 0 50.53 11.66 50.53 25.99c0 14.33-11.33 25.99-25.26 25.99zm0-42.56c-8.76 0-15.88 7.43-15.88 16.57s7.13 16.57 15.88 16.57c8.91 0 15.88-7.28 15.88-16.57S34.17 9.42 25.27 9.42zM103.48 50.94 77.7 17.12v33.82h-9.25V1.04h8.26l25.79 33.9V1.04h9.18v49.9zM150.73 50.94V32.63L131.96 1.04h10.9l12.43 21.44 12.49-21.44h10.97l-18.83 31.59v18.31zM231.2 50.94l-10.59-16.41-10.53 16.41h-11.31l16.34-25.08-15.97-24.82h10.88l10.59 16.31 10.65-16.31h10.89l-15.97 24.82 16.35 25.08z"
        />
      </animated.g>
      <animated.path
        className={className}
        d="M308.63 22.95h-15.39V7.56h-6.08v15.39h-15.39v6.08h15.39v15.39h6.08V29.03h15.39z"
        id="plus"
        style={plusSpringStyle}
      />
      <animated.g id="rose" style={roseSpringStyle}>
        <path
          className={className}
          d="m377.31 50.94-9.73-14.42h-9.69v14.42h-9.19V1.03h23.1c10.8 0 17.25 6.62 17.25 17.71 0 7.49-3.29 13.36-9.02 16.11l-2.04.98 10.31 15.11h-10.99zm-19.41-23h13.19c5.66 0 9.18-3.47 9.18-9.05 0-5.75-3.43-9.19-9.18-9.19H357.9v18.24zM434.01 51.98c-13.7 0-25.27-11.9-25.27-25.99C408.74 11.9 420.31 0 434.01 0c13.93 0 25.27 11.66 25.27 25.99-.01 14.33-11.34 25.99-25.27 25.99zm0-42.56c-8.76 0-15.88 7.43-15.88 16.57s7.13 16.57 15.88 16.57c8.91 0 15.88-7.28 15.88-16.57s-6.98-16.57-15.88-16.57zM499.79 51.98c-11.42 0-19.01-5.17-19.75-13.28h9.15c.99 2.76 4.55 5.24 10.34 5.24 7.85 0 8.45-4.02 8.45-5.26 0-3.83-3.97-5.53-10.04-7.7-8.9-3.09-17.57-6.88-17.57-16.24 0-8.96 7.11-14.75 18.1-14.75 10.88 0 18.35 5.68 18.98 14.25h-9.06c-.78-3.22-4.11-6.21-9.66-6.21-6.05 0-8.19 3.02-8.19 5.6 0 3.75 4.1 5.23 9.76 7.28 7.18 2.65 17.91 6.61 17.91 17 .01 10.38-9.51 14.07-18.42 14.07zM546.52 50.94V1.03H582v9.49h-26.23v11.62h21.56v8.59h-21.56v10.79H582v9.42z"
        />
      </animated.g>
      <animated.path
        className={className}
        d="M0 73.93h582V80H0z"
        id="underline"
        style={underlineSpringStyle}
      />
    </svg>
  )
}
